import React, {useState} from 'react';
import {Button, Form, Input, Label, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {Field, FormikProvider, useFormik} from 'formik';
import * as Yup from "yup";
import {rg2Comm} from 'script/cpmRealgrid2.common';
import CpmRealgrid from 'Components/CpmRealgrid/CpmRealgrid';
import useDidMountEffect from 'script/useDidMountEffect';
import { useExtSubmission } from 'api';

const checkboxList = [
    [
        {label: '거래불가 포함', value: 'noDealYn', disabled: ['chkAf']},
        {label: '추후지정', value: 'chkAf'},
    ]
]

// realgrid 컬럼
const columns = [
    {
        "width": 50,
        "name": "agncyId",
        "header": {
            "text": "광고회사 코드"
        }
    },
    {
        "width": 70,
        "name": "agncyNm",
        "header": {
            "text": "광고회사명"
        }
    }
    ,
    {
        "width": 70,
        "name": "dealStsNm",
        "header": {
            "text": "거래상태"
        }
    }
    , {"visible": false, "name": "agncyTypeCd"}
];

/**
 *
 * User : 이연우
 * Date : 2023.05.08
 * @ file : Components/Common/CpmCommPFindAgncy.js
 * @ Desc : 광고회사 검색 공통 팝업 Component
 * @param {string} agncyStr 외부에서 입력한 값
 * @param {boolean} modalIsOpen 모달 렌더링 여부
 * @param {React.SetStateAction | Function} handleModal 모달 상태 제어 함수
 * @param {React.SetStateAction | Function} onChangeParams 외부 컴포넌트 params 세터 함수
 */
const CpmCommPFindAgncy = ({
                               agncyStr,
                               modalIsOpen,
                               handleModal,
                               onChangeParams ,
                               cable = ""
                           }) => {
    const extSubmission = useExtSubmission();
    const [rows, setRows] = useState([]); // 그리드 row 값
    const [grid, setGrid] = useState(null); // 그리드

    // form 상태 관리
    const formik = useFormik({
        enableReinitialize: true,
        // 초기값
        initialValues: {
            agncyStr: agncyStr || "", // 광고회사
            noDealYn: false, // 거래불가 포함
            chkAf: false, // 추후지정
        },
        // validation 체크
        validationSchema: Yup.object({
            // chkAf가 fasle면 agncyStr 빈값 검사
            agncyStr: Yup.string().when('chkAf', {
                is: true,
                then: (schema) => schema,
                otherwise: (schema) => schema.required(),
            }),
        }),
        // 검색 버튼 클릭시 작동
        onSubmit: (values) => {
            getRows({
                noDealYn: values.noDealYn ? 'Y' : null,
                chkAf: values.chkAf ? 'Y' : null,
                agncyStr: values.agncyStr,
            })
        },
    });

    // 초기 시작
    const onLoad = () => {
        try {
            var options = {};
            options.columns = columns;
            options.scrnPgmId = 'CpmCommPFindAgncy';
            options.menuId = '';
            options.groupingFlag = false;
            options.filterFlag = false;
            options.footerFlag = false;
            options.buttonFlag = false;
            const grid_agncy = rg2Comm.setGridInit("grid_agncy", options);

            grid_agncy.onCellDblClicked = function (grid, clickData) {
                var voJson = grid.getValuesByRow(clickData.dataRow);
                if(voJson.agncyId){
                    onChangeParams(voJson);
                    handleModal(false);
                }
            }

            setGrid(grid_agncy);
        } catch (e) {
            console.log(e);
        }
    };

    // 확인 버튼 클릭 시 
    const onClick_BtnSelect = () => {
        var _row = grid.getCurrent().dataRow;
        var voJson = grid.getValuesByRow(_row);
        voJson.isProc = "Y";
        if (_row > -1) {
            onChangeParams(voJson); // 현재 선택한 컬럼 값으로 광고회사 세팅 
        }
        handleModal(false);
    }

    // 광고회사 상세 리스트 불러오기 (조회)
    const getRows = async (param) => {
        if(cable === "Y") param.cable = "Y";
        extSubmission(
            "/cpm/com/commAgncyOffc/subList.do",
            param ,
            (e, data) => {
                if (data.listMain.length < 1) {
                        alert("조회된 결과가 없습니다.");
                        setRows([]);
                        return false;
                    }
                setRows(data.listMain);
                grid.setJSON(data.listMain);
            }
        );
    }

    useDidMountEffect(() => {
        // 외부 광고회사 input에서 바로 enter로 접근시 바로 광고회사 리스트 검색  
        formik.submitForm(formik.values);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid])

    useDidMountEffect(() => {
        // 모달이 닫히면 상태값, 그리드 초기화 
        if (!modalIsOpen || !agncyStr) {
            setRows([]);
            formik.resetForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalIsOpen])

    const realgridProps = {
        title: '광고회사 목록',
        onLoad, 
        id: 'grid_agncy' ,
        minHeight : "200px" ,
        minWidth : "400px"
    };
    return (
        <>
            <Modal
                size='lg'
                isOpen={modalIsOpen}
                backdrop={'static'}
                id="staticBackdrop"
                centered
                toggle={() => {
                    handleModal();
                }}
            >
                <ModalHeader className="modal-title" id="commPFindAgncy-title" toggle={handleModal}>
                    광고회사 검색(commPFindAgncy)
                </ModalHeader>

                <ModalBody className="p-3">
                    <FormikProvider value={formik}>
                        <Form
                            className='d-flex flex-wrap align-items-center bg-light clearfix ps-2 pt-2 pb-2 mb-2 gap-2 position-relative'
                            style={{paddingRight: 50}}
                            onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                                return false;
                            }}
                            autoComplete="off" >
                            <div className="d-flex align-items-center gap-2">
                                <Label className='m-0 text-nowrap'>
                                    광고회사
                                </Label>
                                <Input
                                    className='form-control-sm form-control'
                                    type="text"
                                    name="agncyStr"
                                    id="agncyStr"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.agncyStr || ""}
                                    invalid={
                                        (formik.touched.agncyStr &&
                                            formik.errors.agncyStr)
                                            ? true
                                            : false
                                    }
                                    disabled={formik.values.chkAf}/>
                            </div>

                            {checkboxList.map((checkboxs, idx) => (
                                <div className='d-flex gap-2 flex-wrap' key={`CHECKBOXS_${idx}`}>
                                    {checkboxs.map((checkbox) => (
                                        <div className="form-check" key={`CHECKBOX_${checkbox.value}`}>
                                            <Field
                                                name={checkbox.value}
                                                id={checkbox.value}
                                                className="form-check-input"
                                                type="checkbox"
                                                disabled={checkbox.disabled ?
                                                    checkbox.disabled.reduce((acc, cur) => {
                                                        return acc && formik.values[cur]
                                                    }, true)
                                                    : false}
                                            />
                                            <Label className="form-check-label" htmlFor={checkbox.value}>
                                                {checkbox.label}
                                            </Label>
                                        </div>
                                    ))}
                                </div>
                            ))}
                            <Button type='submit' color='danger' size='sm'
                                    className='position-absolute end-0 bottom-0 m-2'>
                                검색
                            </Button>
                        </Form>
                    </FormikProvider>

                    <div className='d-flex justify-content-between'>
                        <p className="text-muted m-0"> 검색내역 </p>
                        <p className="text-muted m-0"> 총 <strong>{rows?.length || '0'}</strong> 건 </p>
                    </div>

                    <CpmRealgrid {...realgridProps}/>

                    <div className="hstack gap-2 justify-content-center pt-3">
                        <Button color="dark" onClick={onClick_BtnSelect}>
                            확인
                        </Button>
                        <Button color="primary" onClick={() => handleModal(false)}>
                            취소
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default CpmCommPFindAgncy;
